export default __webpack_public_path__ + "static/media/icon-ob-people.b4084cae.svg";